export default __webpack_public_path__ + "static/media/visa.da9628d6.svg";